import React from 'react';
import { useSelector } from 'react-redux';
import { GridPageStripGamesRecommendationsLoggedIn } from './loggedIn';

export const GridPageStripGamesRecommendations = ({ strip }) => {
    const { isLoggedIn } = useSelector((state) => state.player);

    return (
        isLoggedIn && <GridPageStripGamesRecommendationsLoggedIn strip={strip} />
    );
};
